import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { Fragment } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';

export type NerdTipProps = StructuredContentDocument<{
  children: Array<StructuredContentDocument>;
  rendererProps?: RendererProps;
}>;

export function NerdTip({ props }: NerdTipProps) {
  if (!props?.children?.length) {
    return null;
  }

  return (
    <div
      className={css({
        backgroundColor: 'yellow.lightest',
        borderTopWidth: 'thick',
        borderTopStyle: 'solid',
        borderTopColor: 'primary',
        paddingTop: { base: '4', md: '9' },
        paddingRight: { base: '4', md: '9' },
        paddingBottom: { base: '4', md: '9' },
        paddingLeft: { base: '4', md: '9' },
      })}
      data-testid="page-nerdy-tip"
    >
      <div
        className={css({
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          marginBottom: '1',
          columnGap: '2',
          rowGap: '2',
        })}
      >
        <span className={css({ textStyle: 'textLargeBold' })}>🤓</span>
        <p className={css({ textStyle: 'textBold' })}>Nerdy Tip</p>
      </div>
      {props.children?.map((child, index) => {
        return (
          <Fragment key={index}>{renderStructuredContent(child, props.rendererProps)}</Fragment>
        );
      })}
    </div>
  );
}
